import { Skeleton } from '../../../../ui/elements/Skeleton/Skeleton';

export const InnerLayoutSkeleton = () => {
    return (
        <div className="mx-auto my-2xl max-w-[600px]">
            <Skeleton className="h-[33px] w-[70%] bg-secondary-60" />
            <Skeleton className="mb-2xl mt-xl h-[24px] w-full bg-secondary-80" />
            <Skeleton className="mb-2xl h-[250px] w-full rounded-m bg-secondary-80" />
        </div>
    );
};
